export default function auth({ next, store }) {
  if (!store.state.user) {
    return next({ name: 'login' })
  }
  return next()
}
